import React from 'react';
import { buttonStyles, textStyles, wrapperStyles } from './createStyle';
import { Icon, Typography } from '../../index.react';

var Tag = function Tag(_a) {
  var text = _a.text,
      theme = _a.theme,
      className = _a.className,
      onClose = _a.onClose,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b;
  var finalClassName = wrapperStyles({
    theme: theme,
    className: className,
    size: size
  });
  return React.createElement("div", {
    className: finalClassName
  }, React.createElement(Typography, {
    type: "caption",
    className: textStyles(size)
  }, text), React.createElement("button", {
    className: buttonStyles(size),
    onClick: function onClick() {
      return onClose(text);
    }
  }, React.createElement(Icon, {
    name: "close",
    size: "xs",
    height: "11px"
  })));
};

export default Tag;